import { render } from "./UserNav.vue?vue&type=template&id=ba9c8878&ts=true"
import script from "./UserNav.vue?vue&type=script&lang=ts"
export * from "./UserNav.vue?vue&type=script&lang=ts"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__